import { authorizedEmailSlice } from 'common/store/authorizedEmails';
import { franchiseSlice } from 'common/store/franchises';
import { galleryCommentSlice } from 'common/store/galleryComments';
import { galleryImageSlice } from 'common/store/galleryImages';
import { projectSlice } from 'common/store/projects';
import { AppState, appStore } from 'common/store/store';
import { submissionSlice } from 'common/store/submissions';
import { territorySlice } from 'common/store/territories';
import { userSlice } from 'common/store/users';
import React from 'react';
import { useSelector } from 'react-redux';
import { zoneSlice } from '../../common/store/zoneSlice';
import { Broadcaster } from '../libraries/broadcaster';

export default (props: { children: React.ReactNode | React.ReactNode[]; }) => {

    const [connect, setConnect] = React.useState(false);
    const user = useSelector((state: AppState) => state.device.user);

    React.useEffect(() => {
        setConnect(!!user?.id);
    }, [user]);

    return <Broadcaster
        connect={connect}
        store={appStore}
        slices={{
            'users': userSlice,
            'projects': projectSlice,
            'authorizedEmails': authorizedEmailSlice,
            'franchises': franchiseSlice,
            'galleryComments': galleryCommentSlice,
            'galleryImages': galleryImageSlice,
            'submissions': submissionSlice,
            'territories': territorySlice,
            'zones': zoneSlice
        }}
    >{props.children}</Broadcaster>;
};
